const AbaTitulo = (props) => {
    // If textOnly prop is true, only show text without logo
    if (props.textOnly) {
        return <div className={props.class}>
            <span>{props.texto}</span>
        </div>
    }
    
    if (props.isGacc) {
        return <div className={props.class} style={{padding:0,margin:0}}>
            <img src={props.src} alt={props.alt} width="120px" height="25px"  />
            <span>{props.texto}</span>
        </div>
    }
    return (
        <>{props.isGpay === true ?
            <div className={props.class}>
                <img src={props.src} alt={props.alt} width="70px" height="16px" style={{ marginRight: "0.5em", marginBottom: "0.2em" }} />
                <span>{props.texto}</span>
            </div> :
            <div className={props.class}>
                <img src={props.src} alt={props.alt} width="16px" height="16px" style={{ marginRight: "0.5em", marginBottom: "0.2em" }} />
                <span>{props.texto}</span>
                {props.src2 && <><img src={props.src2} alt={props.alt} width="16px" height="16px" style={{ marginLeft: "0.5em", marginBottom: "0.2em" }} /></>}
            </div>}

        </>)
}

export default AbaTitulo;